import Requester from "../helpers/Requester";
import App from "../layouts/app";
import { router } from "@inertiajs/react";
import ContentWrapper from "../components/ContentWrapper";
import PageTitle from "../components/PageTitle";
import MatchForm from "../components/MatchForm";
import { Opponent } from "./Opponents";

export default function MatchAdd({ opponents }: { opponents: Opponent[] }) {

    const saveMatch = (form: any) => {
        const requester = new Requester();

        const data = new FormData();

        Object.keys(form).forEach((key) => {
            data.append(key, form[key]);
        });

        requester.post(requester.getUrl(`api/matches`), data).then((response) => {
            router.visit(`/admin/matches`);
        }).catch((error) => {
            alert("Error adding match: " + error.message);
        })
    }

    return (
        <App>
            <PageTitle title="Add Match" />
            <ContentWrapper>
                <MatchForm onSubmit={saveMatch} opponents={opponents} />
            </ContentWrapper>
        </App >
    )
}